var React = require('react');

function HeightIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"XMLID_227_","d":"M240,225h-60V105h60c6.067,0,11.536-3.655,13.858-9.26c2.321-5.605,1.038-12.057-3.252-16.347l-75-75\r\n\tc-5.857-5.858-15.355-5.858-21.213,0l-75,75c-4.29,4.29-5.573,10.742-3.252,16.347C78.464,101.345,83.933,105,90,105h60v120H90\r\n\tc-6.067,0-11.536,3.655-13.858,9.26c-2.321,5.605-1.038,12.057,3.252,16.347l75,75C157.322,328.536,161.161,330,165,330\r\n\tc3.839,0,7.678-1.464,10.606-4.394l75-75c4.29-4.29,5.573-10.742,3.252-16.347C251.536,228.655,246.068,225,240,225z M165,36.214\r\n\tL203.787,75h-77.574L165,36.214z M165,293.787L126.213,255h77.574L165,293.787z"}));
}

HeightIconInline.defaultProps = {"fill":"#000000","height":"800px","width":"800px","version":"1.1","id":"Layer_1","viewBox":"0 0 330 330","xmlSpace":"preserve"};

module.exports = HeightIconInline;

HeightIconInline.default = HeightIconInline;
